$(document).ready(function(){
  $('.banner-slides').slick({
    infinite: true,
  	speed: 2000,
  	slidesToShow: 1,
  	slidesToScroll: 1,
  	centerMode: true,
    arrows: true,
    appendArrows: ".banner-navigation",
    slide: ".banner-slide",
    initialSlide: 0,
    fade: true,
    adaptiveHeight: false,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 2000,
  });


  $('.logo-slides').slick({
    infinite: true,
  	speed: 150,
  	slidesToShow: 5,
  	slidesToScroll: 1,
  	centerMode: false,
  	variableWidth: true,
      appendArrows: ".slider-navigation",
  });
});
